import RewardSlickPane from './RewardSlickPane';

export default RewardSlickPane;
